import { trpc } from '@/shared/api/trpc';

export const useAccountsForFilters = (enabled = true) =>
  trpc.accounts.listForFilters.useQuery(undefined, { enabled });
